import axios from 'axios'
// import gettoken from './gettoken'
import baseurl, { axiosPrivet } from './baseurl'

import jwtDefaultConfig from './jwtDefaultConfig'
import { showVersionUpdateDialog } from '../../../utility/versionUpdateDialog'

export default class JwtService {
  // ** jwtConfig <= Will be used by this service
  jwtConfig = { ...jwtDefaultConfig }

  // ** For Refreshing Token
  isAlreadyFetchingAccessToken = false

  // ** For Refreshing Token
  subscribers = []

  constructor(jwtOverrideConfig) {
    this.jwtConfig = { ...this.jwtConfig, ...jwtOverrideConfig }

    // ** Request Interceptor
    baseurl.interceptors.request.use(
      (config) => {
        // ** Get token from localStorage
        const accessToken = this.getToken()

        // console.log(accessToken)

        // ** If token is present add it to request's Authorization Header
        // console.log((tokendecode.exp - secondsSinceEpoch) / 3600)
        if (accessToken) {
          // ** eslint-disable-next-line no-param-reassign
          config.headers.Authorization = `${this.jwtConfig.tokenType} ${accessToken}`
          config.headers['X-App-Name'] = 'Portal'
        }

        return config
      },
      (error) => Promise.reject(error)
    )

    // ** Add request/response interceptor
    baseurl.interceptors.response.use(
      (response) => {

        const responseVersion = response.headers['x-app-version']
        console.log('responseVersion:', responseVersion)

        if (responseVersion) {
          const storedVersion = localStorage.getItem('app-version')
          console.log('storedVersion:', storedVersion)
          if (storedVersion && storedVersion !== responseVersion) {
            // ** Show alert to user about version update
            showVersionUpdateDialog(responseVersion).then((shouldUpdate) => {
              if (shouldUpdate) {
                // ** Update stored version
                localStorage.setItem('app-version', responseVersion)
                // ** Refresh the page
                window.location.reload()
              }
            }).catch((error) => {
              console.error('Error showing version update dialog:', error)
              // ** Fallback: update version silently
              localStorage.setItem('app-version', responseVersion)
            })
          } else if (!storedVersion) {
            // ** Store version if not exists
            localStorage.setItem('app-version', responseVersion)
            console.log('Stored new version:', responseVersion)
          }
        } else {
          console.log('No version header found in response from:', response.config.url)
        }

        return response
      },
      (error) => {
        const { config } = error
        const originalRequest = config

        const jsonError = error.toJSON()
        if (jsonError.status === 401) {

          this.refreshToken().then((r) => {
            if (r.status === 200) {
              this.onAccessTokenFetched(r.data.access_token)
            }
          }).catch(() => {
            localStorage.removeItem(this.jwtConfig.storageTokenKeyName)
            localStorage.removeItem(this.jwtConfig.storageRefreshTokenKeyName)
            localStorage.removeItem('userData')
            localStorage.removeItem('configApp')
            window.navigation.navigate(`${window.location.origin}/login`)
          })

          const retryOriginalRequest = new Promise((resolve) => {
            this.addSubscriber((accessToken) => {
              // ** Make sure to assign accessToken according to your response.
              // ** Check: https://pixinvent.ticksy.com/ticket/2413870
              // ** Change Authorization header
              originalRequest.headers.Authorization = `${this.jwtConfig.tokenType} ${accessToken}`
              resolve(baseurl(originalRequest))
            })
          })
          return retryOriginalRequest
        }
        return Promise.reject(error)
      }
    )
  }

  onAccessTokenFetched(accessToken) {
    this.subscribers = this.subscribers.filter((callback) => callback(accessToken))
  }

  addSubscriber(callback) {
    this.subscribers.push(callback)
  }

  getToken() {
    const token = localStorage.getItem(this.jwtConfig.storageTokenKeyName)
    if (token) {
      return token.split('"').join('')
    }
  }

  getRefreshToken() {
    return localStorage.getItem(this.jwtConfig.storageRefreshTokenKeyName)
  }

  setToken(value) {
    localStorage.setItem(this.jwtConfig.storageTokenKeyName, value)
  }

  setRefreshToken(value) {
    localStorage.setItem(this.jwtConfig.storageRefreshTokenKeyName, value)
  }

  async login(args) {
    const params = new URLSearchParams()
    params.append('grant_type', 'password')
    params.append('username', args.userNameOrEmailAddress)
    params.append('password', args.password)
    params.append('client_id', 'IFDA_App')
    params.append('scope', 'address email phone profile roles IFDA offline_access')

    if (args.with2fa) {
      params.append('TwoFactorProvider', args.TwoFactorProvider)
      params.append('TwoFactorCode', args.TwoFactorCode)
    }

    const options = {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    }
    try {
      const res = await axiosPrivet.post(this.jwtConfig.loginEndpoint, params, options)

      return res.data
    } catch (err) {
      return Promise.reject(err.response)
    }
  }

  async Main(path, args) {
    return await baseurl.get(this.jwtConfig.mainEndPoint + path, args)
  }
  async MainPost(path, ...args) {
    return await baseurl.post(this.jwtConfig.mainEndPoint + path, ...args)
  }

  register(...args) {
    return axios.post(this.jwtConfig.registerEndpoint, ...args)
  }

  async refreshToken(refreshtoken) {
    const params = new URLSearchParams()
    params.append('grant_type', 'refresh_token')
    params.append('refresh_token', refreshtoken)
    params.append('client_id', 'IFDA_App')
    const options = {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    }

    const res = await baseurl.post('/connect/token', params, options)
    this.setToken(res.data.access_token)
    this.setRefreshToken(res.data.refresh_token)
    return res
  }

  async refreshToken() {
    let _refToken = this.getRefreshToken()

    try {
      _refToken = JSON.parse(_refToken)
    } catch (error) {
      _refToken = ''
    }

    const params = new URLSearchParams()
    params.append('grant_type', 'refresh_token')
    params.append('refresh_token', _refToken)
    params.append('client_id', 'IFDA_App')

    const res = await baseurl.post(this.jwtConfig.refreshEndpoint, params, {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    })
    if (res.status === 200) {
      this.setToken(JSON.stringify(res.data.access_token))
      this.setRefreshToken(JSON.stringify(res.data.refresh_token))
    }
    return res
  }
}
